export const INQUIRY_FORM_URL = 'https://forms.gle/rfJPfdoQqYEnDebJ7';
